var player;
;(function($$){
	function Player(){
        
    }
    Player.prototype.youtube = function(video_content){
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        var video_content = document.getElementById(video_content);
        return function () {
            player = new YT.Player('youtube_player', {
                height: '100%',
                width: '100%',
                videoId: video_content.getAttribute('video_id'),
                playerVars: {modestbranding:1, title:'', playsinline:1, autoplay:1, controls:0, disablekb:0, loop:1, rel:0, iv_load_policy:3},
                events: {
                onReady: function onPlayerReady(event) {
                    event.target.mute();
                    event.target.playVideo();
                },
                onStateChange: function onPlayerStateChange(event) {
                    if (event.data == YT.PlayerState.ENDED) {
                        event.target.playVideo();
                    }      
                }
                }
            });
        }
    }
    $$.Player = new Player();
})(window)